/**
 * StatusPill — farbige Status-Kapsel (Design-Vorlage: .pill / .pill-*).
 * Reines Darstellungselement; das Label wird bereits uebersetzt uebergeben
 * (Status-Bedeutung ist seitenspezifisch: online/offline, paid/refunded, ...).
 *
 * Props:
 * - variant: 'success' | 'warning' | 'danger' | 'primary' | 'accent' | 'info' | 'neutral'
 * - label: string      Angezeigter Text (vom Aufrufer uebersetzt)
 * - dot?: boolean       Farbigen Punkt voranstellen (Default true)
 * - className?: string  Zusaetzliche Klassen
 */
type StatusPillVariant = 'success' | 'warning' | 'danger' | 'primary' | 'accent' | 'info' | 'neutral'

type StatusPillProps = {
  variant: StatusPillVariant
  label: string
  dot?: boolean
  className?: string
  'data-testid'?: string
  title?: string
}

export function StatusPill({
  variant,
  label,
  dot = true,
  className = '',
  title,
  'data-testid': testId,
}: StatusPillProps) {
  const variantClass = variant === 'neutral' ? '' : ` pill-${variant}`
  return (
    <span
      className={`pill${variantClass}${className ? ` ${className}` : ''}`}
      title={title}
      data-testid={testId}
    >
      {dot && <span className="dot" />}
      {label}
    </span>
  )
}
